export const MOTION_MS = 500

export const REDUCED_MOTION = {
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    animation: 'none'
  }
}
